import { Outlet, createFileRoute } from '@tanstack/react-router';
import { ClerkSignUpPage } from '@/components/auth/ClerkAuthPages';

export const Route = createFileRoute('/auth/sign-up')({
  component: SignUpLayout,
});

function SignUpLayout() {
  return (
    <>
      <ClerkSignUpPage />
      <Outlet />
    </>
  );
}
